import gql from 'graphql-tag';

import { PhotoForegroundDetails } from '../../../../graphql/fragments/photo';

const cardElementConfigurationDetails = gql`
  fragment cardElementConfigurationDetails on ICardElementConfiguration {
    ... on ICardElementConfiguration {
      id
      card_element {
        id
        type
        frame {
          width
          height
          x
          y
        }
        z_index
      }
      border {
        type
        width
        color
        opacity
      }
      corner_radius
      help_placeholder
      is_editable
      is_pro_editable
      is_printable
      label
    }

    ... on CardPhotoElementConfiguration {
      background_color
      asset_image {
        id
        url
        width
        height
        original_filename
      }
      photo {
        id
        thumbnail_urls(ignore_watermark: true) {
          size_code
          width
          height
          url
        }
        faceblocked_thumbnail_urls {
          url
          size_code
          width
          height
          blur_type
          regions
        }
        is_entitled_matched_photo
        is_owner
        matched_photos {
          total
          records {
            id
            faceblocked_thumbnail_urls {
              url
              size_code
              width
              height
              blur_type
              regions
            }
          }
        }
        ...PhotoForegroundDetails
      }
      photo_url
      cropbox {
        x
        y
        scale
        rotation
      }
      box_shadow {
        offset_x
        offset_y
        color
        opacity
        blur_radius
      }
      opacity
      photo_type
    }

    ... on CardRectangleElementConfiguration {
      color
      opacity
    }

    ... on CardStickerElementConfiguration {
      system_sticker {
        id
        asset_image {
          id
          url
        }
        is_active
      }
    }

    ... on CardTextElementConfiguration {
      text
      font_family
      font_size
      font_color
      text_align
      font_weight
      font_style
      text_transform
      text_fit_enabled
      text_shadow {
        offset_x
        offset_y
        color
        opacity
        blur_radius
      }
      opacity
    }

    ... on CardAddressElementConfiguration {
      use_family_name
      external_shipping_addresses(slice: { limit: 9999 }) {
        total
        records {
          id
          name
          address_line_1
          address_line_2
          city
          post_code
          state
          country {
            id
            name
            iso
            iso3
          }
        }
      }
      roster_identity_linked_identity_addresses(slice: { limit: 9999 }) {
        total
        records {
          id
          name
          address_line_1
          address_line_2
          city
          post_code
          state
          country {
            id
            name
            iso
            iso3
          }
        }
      }
    }
  }
  ${PhotoForegroundDetails}
`;

export default cardElementConfigurationDetails;
